module.exports = __webpack_public_path__ + "img/ico3.d3fcb3a4.png";